<template>
  <b-col
    cols="12"
    md="12"
    sm="12"
    lg="auto"
    class="desktop-five"
  >

    <b-card
      class="summary-card rounded-lg"
      :style="[cardStyle, cardShadow, cardBorder]"
      :border-variant="borderVariant"
    >

      <b-card-body
        class="summary-card-body"
      >
        <div
          class="transaction-item"
        >
          <b-tooltip
            :target="title"
            variant="primary"
            triggers="hover"
          >
            {{ __numberWithCommas(sum) }}
          </b-tooltip>
          <div
            :id="title"
            class="font-weight-bolder text-center sum-number"
          >
            {{ __numberWithCommas(smartFormatter(sum) ) }}
          </div>
          <div
            :id="`title-${_uid}`"
            class="font-weight-bolder text-center"
          >
            {{ title }}
          </div>

          <b-tooltip
            :target="`title-${_uid}`"
            variant="primary"
            triggers="hover"
          >
            {{ title.length > 15 ? title.slice(0, 15) + '...' : title }}
          </b-tooltip>

          <div
            v-if="count"
            class="text-center"
            style="font-size: 0.8rem"
          >
            {{ __numberWithCommas(count) }} Orders
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>
import {
  BCol,
  BCard,
  BCardBody,
  BTooltip,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'

export default {
  name: 'SummaryCard',
  components: {
    BCol,
    BCard,
    BCardBody,
    BTooltip,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    sum: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
    borderVariant: {
      type: String,
      default: '',
    },
    bgVariant: {
      type: String,
      default: '',
    },
    textVariant: {
      type: String,
      default: '',
    },
  },
  computed: {
    cardStyle() {
      const style = {
        backgroundColor: this.bgVariant,
        color: this.textVariant,
        width: this.cardWidth,
      }
      return style
    },
    cardShadow() {
      return {
        boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15) !important',
        transition: 'box-shadow 0.3s ease-in-out !important',
      }
    },
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
  methods: {
    kFormatter,
    formatNumber(value) {
      const str = this.numberWithCommas(value).toString()
      return str.length > 10 ? `${str.slice(0, 10)}...` : str
    },
    numberWithCommas(x, isFloat = false) {
      if (Number.isNaN(x)) return x
      const parts = parseFloat(x).toFixed(isFloat ? 2 : 0).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    },
    smartFormatter(value) {
      const abs = Math.abs(value)
      if (abs >= 1.0e9) {
        return `${(value / 1.0e9).toFixed(1)}B`
      }
      if (abs >= 1.0e6) {
        return `${(value / 1.0e6).toFixed(1)}M`
      }
      if (abs >= 1.0e3) {
        return `${(value / 1.0e3).toFixed(1)}K`
      }
      return value.toString()
    },
  },
}
</script>
<style scoped>
.summary-card-body {
  padding-top:0;
  padding-bottom:0;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  min-height: 50px;
}
b-card {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25) !important;
  transition: box-shadow 0.3s ease-in-out, border-width 0.3s ease-in-out !important;
}

b-card:hover {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25) !important;
}
.sum-number {
  font-size: 24px;
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .summary-card {
    width: auto;
  }
}

@media (min-width: 1600px) {
  .summary-card {
    width: auto;
  }
}
.desktop-five {
  flex: 0 0 100%;
  max-width: 100%;
}

@media (min-width: 1200px) {
  .desktop-five {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

</style>
